import { type FC } from "react";

import { FOLLOWING_QUERY_PARAM } from "components/constants";
import { PillBannerButton } from "components/footer/PillBannerButton";
import { type PresentationBannerColorType } from "components/footer/PresentationBanner";
import { t } from "i18n/i18n";
import { useIsMdOrLarger } from "mds/hooks/use-responsive";
import { useCapabilities } from "store/capability-hooks";
import { useAppDispatch, useAppSelector } from "store/index";
import {
  selectCurrentSectionId,
  selectIsPresentationActive,
  selectPresentedPageId,
} from "store/selectors";
import { localStateActions } from "store/slices/local";
import { Link } from "utils/routing";
import { pageUrl, withQueryParams } from "utils/urls";

interface FollowButtonProps {
  color: PresentationBannerColorType;
  showReturnText?: boolean;
}

export const FollowButton: FC<FollowButtonProps> = ({ color, showReturnText = false }) => {
  const sectionId = useAppSelector(selectCurrentSectionId) || "";
  const isPresentationActive = useAppSelector(selectIsPresentationActive);
  const presentedPageId = useAppSelector(selectPresentedPageId);
  const showShortText = !useIsMdOrLarger();
  const { canParticipateInSection } = useCapabilities();
  const dispatch = useAppDispatch();

  if (!sectionId || !isPresentationActive || !presentedPageId) {
    return null;
  }

  const presentedPageURL = withQueryParams(pageUrl(sectionId, presentedPageId), {
    [FOLLOWING_QUERY_PARAM]: "active",
  });

  const closeSidebar = () => {
    if (canParticipateInSection) {
      dispatch(localStateActions.setIsSidebarOpen(false));
    }
  };

  return (
    <PillBannerButton
      as={Link}
      eventName="Presentation - Follow along"
      kind={`banner-${color}`}
      to={presentedPageURL}
      onClick={closeSidebar}
    >
      {showReturnText
        ? t("common.return")
        : showShortText
          ? t("main_header.follow_short")
          : t("main_header.follow")}
    </PillBannerButton>
  );
};
